
import  {MODAL_CAJA_VISIBLE,
 MODAL_CAJA_OCULTO, SET_VISIBLE } from '../actions/constants/caja.constants'

 const initialState = {
    isOpen:false,
    setVisible:false,
  };

export default function handleCajaModal(state=initialState, action) {

    const { type, payload } = action;

    switch (type) {
        case MODAL_CAJA_VISIBLE: {
          const {isOpen}=true;
          return {
            ...state, isOpen,
          };
        }
        case  MODAL_CAJA_OCULTO : {
          const { isOpen } = false;
          return {
            ...state, isOpen,
          };
        }
        case SET_VISIBLE:{
          const { isOpen } = state;
          return { ...state, isOpen: !isOpen };
        }
        default: return state;
    }
}

